import { Collapse, CollapseProps, theme } from 'antd';
import styles from './index.module.less';
import { CSSProperties, useEffect, useMemo } from 'react';
import { useConfigProvider } from '@/context/ConfigProvider';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { CommonBackContent } from '@/components/Layouts/CommonBackContent';
import Link from 'next/link';
import { getFaqDataList } from './FaqData';

const FAQContent = () => {
  const { t } = useTranslation('common');
  const { token } = theme.useToken();
  const { isBlogWeb } = useConfigProvider();
  const router = useRouter();

  // 使用抽离的FAQ数据
  const dataList = useMemo(() => {
    const faqList = getFaqDataList(t);

    // 处理包含链接的FAQ项目
    return faqList.map((item, index) => {
      if (index === 4) {
        // "How can I anonymously view someone's Instagram Stories?" 项目
        return {
          ...item,
          children: (
            <>
              <span>{t(`To anonymously view someone's Instagram Stories, you can use DolphinRadar's`)}</span>
              {` `}
              <Link style={{ color: 'blue' }} href="/anonymous-instagram-story-viewer">
                {t(`Anonymous Story Viewer`)}
              </Link>
              <span>
                {t(
                  `. This tool allows you to watch any public Instagram Stories without the user knowing, ensuring your privacy.`
                )}
              </span>
            </>
          ),
        };
      }

      if (index === 5) {
        // "How can I see who someone liked or followed on Instagram?" 项目
        return {
          ...item,
          children: (
            <>
              <span>{t(`If you want to track who someone has liked or followed on Instagram, DolphinRadar's`)}</span>
              {` `}
              <Link style={{ color: 'blue' }} href="/">
                {t(`Instagram Activity Tracker`)}
              </Link>
              {` `}
              <span>
                {t(
                  `is the perfect solution. It provides detailed reports on their Instagram activity, including likes, new follows, and more.`
                )}
              </span>
            </>
          ),
        };
      }

      if (index === 6) {
        // "Does this support Threads content?" 项目
        return {
          ...item,
          children: (
            <>
              <span>
                {t(
                  `Not directly. But we've already launched a tool that lets you download Threads videos, images, and GIFs in one click — try our`
                )}
              </span>{' '}
              <Link style={{ color: '#725CFF' }} href="/threads-downloader">
                {t(`Threads Downloader`)}
              </Link>
              {t('.')}
            </>
          ),
        };
      }

      return item;
    });
  }, [t]);

  useEffect(() => {
    if (isBlogWeb) {
      router.push('/instagram-tracking-blog');
    }
  }, []);

  const panelStyle: React.CSSProperties = {
    marginBottom: 24,
    background: 'transparent',
    borderRadius: token.borderRadiusLG,
    border: 'none',
    color: 'red',
    boxShadow: `0 0 10px #E3E6F3`,
  };

  const getItems: (panelStyle: CSSProperties) => CollapseProps['items'] = (panelStyle) => {
    let tempList;
    tempList = dataList;

    return tempList.map((item, index) => {
      return {
        label: item?.label,
        children:
          typeof item?.children === 'string' ? (
            <p dangerouslySetInnerHTML={{ __html: item?.children }} />
          ) : (
            item?.children
          ),
        key: `${index}`,
        style: panelStyle,
      };
    });
  };

  const getContent = useMemo(() => {
    return (
      <CommonBackContent style={{ background: 'transparent' }}>
        <div className={styles.content}>
          <div className={styles.topContainer}>
            <h2>{t("Frequently Asked Questions about Dolphin Radar's Post Viewer")}</h2>
            <div style={{ display: 'none' }}>
              {dataList.map((item, index) => {
                return <h3 key={index}>{item?.label}</h3>;
              })}
            </div>
          </div>

          <Collapse
            className={styles.collapseContent}
            bordered={false}
            items={getItems(panelStyle)}
            defaultActiveKey={undefined}
          />
        </div>
      </CommonBackContent>
    );
  }, [getItems]);

  if (isBlogWeb) {
    return <></>;
  }
  return <>{getContent}</>;
};

export default FAQContent;
